import React from "react";

const FilterBar = ({
  searchTerm,
  setSearchTerm,
  filterStatus,
  setFilterStatus,
  dateRange,
  setDateRange,
  onExport
}) => {
  // Removed "Archived" from the status orchestration
  const statuses = ["All", "Active", "Inactive"];
  const ranges = [
    { label: "7D", value: 7 },
    { label: "1M", value: 30 },
    { label: "3M", value: 90 },
    { label: "6M", value: 180 },
    { label: "1Y", value: 365 },
  ];
 
  return (
    <div className="flex flex-col gap-6 mb-8">
      {/* --- TOP ROW: SEARCH & STATUS --- */}
      <div className="bg-white p-4 rounded-[1.5rem] border border-slate-100 shadow-sm flex flex-col lg:flex-row gap-4 items-center">
        {/* MULTI-FIELD SEARCH: Name, Email, Company, Mobile */}
        <div className="relative flex-1 w-full group">
          <span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-[#0B1C2D] transition-colors">
            manage_search
          </span>
          <input
            type="text"
            placeholder="Search by name, email, company, or mobile..."
            className="w-full pl-12 pr-4 py-3 bg-slate-50 border-none rounded-2xl text-sm focus:ring-2 focus:ring-slate-200 outline-none transition-all placeholder:text-slate-400 font-medium"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {searchTerm && (
            <button
              onClick={() => setSearchTerm("")}
              className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-300 hover:text-slate-600 transition-colors"
            >
              <span className="material-symbols-outlined text-[18px]">
                cancel
              </span>
            </button>
          )}
        </div>

        {/* STATUS SELECTOR: Filter by Active/Inactive/All */}
        <div className="flex bg-slate-100 p-1 rounded-2xl w-full lg:w-auto">
          {statuses.map((status) => (
            <button
              key={status}
              onClick={() => setFilterStatus(status)}
              className={`flex-1 lg:flex-none px-8 py-2.5 text-[10px] font-black uppercase tracking-[0.1em] rounded-xl transition-all duration-200 ${
                filterStatus === status
                  ? "bg-white text-[#0B1C2D] shadow-lg shadow-slate-200/40"
                  : "text-slate-400 hover:text-slate-600"
              }`}
            >
              {status}
            </button>
          ))}
        </div>
      </div>

      {/* --- BOTTOM ROW: TIME SORTING & UTILITIES --- */}
      <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3 sm:gap-4 px-1">
        <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 min-w-0">
          <div className="flex items-center gap-2 shrink-0">
            <span className="material-symbols-outlined text-[18px] text-slate-300">
              calendar_today
            </span>
            <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest">
              Registration Timeframe
            </span>
          </div>

          <div className="flex bg-white border border-slate-100 p-1 rounded-xl shadow-sm overflow-x-auto no-scrollbar">
            {ranges.map((range) => (
              <button
                key={range.label}
                onClick={() => setDateRange(range.value)}
                className={`shrink-0 px-3 sm:px-4 py-1.5 text-[9px] font-black uppercase rounded-lg transition-all duration-200 ${
                  dateRange === range.value
                    ? "bg-[#0B1C2D] text-white shadow-md shadow-[#0B1C2D]/20"
                    : "text-slate-400 hover:bg-slate-50"
                }`}
              >
                {range.label}
              </button>
            ))}
          </div>
        </div>

        {/* Action Utilities */}
        <div className="flex items-center gap-2">
          <button
            onClick={onExport}
            className="w-full sm:w-auto flex items-center justify-center gap-2 px-5 py-2.5 bg-white border border-slate-200 rounded-xl text-[10px] font-black uppercase tracking-widest text-slate-600 hover:bg-[#0B1C2D] hover:text-white hover:border-[#0B1C2D] transition-all duration-300 group active:scale-95"
          >
            <span className="material-symbols-outlined text-[18px] text-slate-400 group-hover:text-white transition-colors">
              file_download
            </span>
            Export
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
